import React, { useEffect, useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, FormGroup, Label, Input } from "reactstrap"

/**
 * Firmaya tanımlı modülün iptali.
 *
 * <p>Kayıt silinmez; {@code CANCELLED} olarak işaretlenir ve gerekçesi saklanır.
 * Bu ayrım iade taleplerinde gereklidir: hangi hakkın hangi tarihte, hangi
 * sebeple kaldırıldığı sorusu sonradan cevaplanabilir olmalıdır.
 *
 * <p>İptal <b>para iadesi yapmaz</b> — iade PayTR tarafında ayrıca işletilir.
 * Kullanıcının bunu sanmaması için modalde açıkça yazılıdır.
 */
const AddonCancelModal = ({ isOpen, toggle, addon, onConfirm }) => {
  const [reason, setReason] = useState("")
  const [saving, setSaving] = useState(false)

  useEffect(() => { if (isOpen) setReason("") }, [isOpen])

  const handleConfirm = async () => {
    try {
      setSaving(true)
      await onConfirm(addon, reason)
    } finally {
      setSaving(false)
    }
  }

  const paid = Number(addon?.paidAmount || 0) > 0

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="text-danger">
        <i className="bx bx-x-circle me-2" />
        Modülü İptal Et
      </ModalHeader>
      <ModalBody>
        <div className="text-center mb-3">
          <i className="bx bx-error-circle text-danger" style={{ fontSize: 48 }} />
          <p className="mt-2 mb-0">
            Bu modülü iptal etmek istediğinize emin misiniz? Firma, modülün verdiği
            hakları iptalden hemen sonra kaybeder.
          </p>
        </div>

        <div className="bg-light rounded-3 p-3">
          <div className="d-flex justify-content-between mb-1">
            <span className="text-muted" style={{ fontSize: ".82rem" }}>Modül</span>
            <span className="fw-semibold">{addon?.moduleName}</span>
          </div>
          <div className="d-flex justify-content-between mb-1">
            <span className="text-muted" style={{ fontSize: ".82rem" }}>Firma</span>
            <span>{addon?.companyName || "-"}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-muted" style={{ fontSize: ".82rem" }}>Kaynak</span>
            <span>{addon?.sourceLabel || addon?.source}</span>
          </div>
        </div>

        <FormGroup className="mt-3 mb-0">
          <Label>Gerekçe</Label>
          <Input
            type="textarea"
            rows={2}
            maxLength={500}
            placeholder="Boş bırakılırsa “Yönetici tarafından iptal edildi” yazılır"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </FormGroup>

        {paid && (
          <div className="mt-3 p-3 rounded-3" style={{ background: "#FFF4E5", border: "1px solid #FFD8A8" }}>
            <i className="bx bx-info-circle me-1" style={{ color: "#B86E00" }} />
            <span style={{ fontSize: ".8rem" }}>
              Bu modül için ödeme alınmış. İptal <strong>para iadesi yapmaz</strong>;
              iade işlemini ayrıca yürütmeniz gerekir.
            </span>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={saving}>Vazgeç</Button>
        <Button color="danger" onClick={handleConfirm} disabled={saving}>
          {saving ? <Spinner size="sm" /> : "Evet, İptal Et"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddonCancelModal
